<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg></span>
            Ny kontrakt
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheSelectInput v-model="form.Avdelingsid" containerClassName="cell medium-6" label="Avdeling" name="Avdelingsid" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.avdeling"/>
            <TheSelectInput v-model="form.Kontrakttype" containerClassName="cell medium-6" label="Kontraktstype" name="Kontrakttype" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.kontrakttype"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheSelectInput v-model="form.Mottaker" containerClassName="cell medium-6" label="Kontraktansvarlig" name="Mottaker" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.mottaker"/>
            <TheDecimalInput containerClassName="cell medium-6" symbol="%" label="Salær" name="Salar" v-model.trim="form.Salar" maxlength="10" v-validate="'max:10|decimal'"/>

            <div class="cell large-12">
              <label for="Legtype">Legitimasjonstype</label>
              <div class="select-container" :class="{ 'form-error': errors.has('Legtype') }">
                <select id="Legtype" name="Legtype" v-model="form.Legtype" @change="$validator.validate('Legitimert'); form.Legitimert = false;">
                  <option v-for="option in instillinger.legitimasjon" v-bind:value="option.key" v-bind:key="option.key">{{option.val}}</option>
                </select>
                <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
                <span class="form-error-label" v-if="errors.has('Legtype')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('Legtype')}}
                </span>
              </div>
            </div>

            <div class="cell small-12 medium-6">
              <label>Legitimert <span v-if="form.Legtype">*</span></label>
              <div class="radio-button-container" :class="{ 'form-error': errors.has('Legitimert') }">
                <ul>
                  <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="false" name="Legitimert" id="ikke-legitimert" v-validate="{ required: true, included: form.Legtype ? ['true', true] : [] }"> <label for="ikke-legitimert">Nei</label></li>
                  <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="true" name="Legitimert" id="legitimert" checked> <label for="legitimert">Ja</label></li>
                </ul>
              </div>
              <div class="cell small-12 large-12 medium-12" style="margin-top: -1.3rem;">
                <div class="input-container" :class="{ 'form-error': errors.has('Legitimert') }">
                  <span class="form-error-label" v-if="errors.has('Legitimert')">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                    Vennligst bekreft legitimasjonen
                  </span>
                </div>
              </div>
            </div>
            <div class="cell small-12 medium-6">
              <label>Reise *</label>
              <div class="radio-button-container" :class="{ 'form-error': errors.has('Reise') }">
                <ul>
                  <li><input type="radio" v-model="form.Reise" v-bind:value="false" name="Reise" id="ikke-reise"> <label for="ikke-reise">Nei</label></li>
                  <li><input type="radio" v-model="form.Reise" v-bind:value="true" name="Reise" id="reise" checked> <label for="reise">Ja</label></li>
                </ul>
                <span class="form-error-label" v-if="errors.has('Reise')" style="position: relative; bottom: -0.5rem">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  Vennligst bekreft reise
                </span>
              </div>
            </div>

            <TheTextInput v-model.trim="form.Kontraktinfo"  containerClassName="cell large-12" label="Kontraktinfo (vil vises på bankoverføring til selger)" name="Kontraktinfo" maxlength="34" v-validate="'max:34'"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import KontraktService from '@/services/KontraktService'
import KundeService from '@/services/KundeService'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktCreateModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {},
      instillinger: {
        mottaker: [],
        avdeling: [],
        kontrakttype: [],
        kontrakttypeAll: [],
        legitimasjon: []
      },
      loading: true
    }
  },
  created () {
    // Set form not submittable
    this.setFormLoading(true)

    // Make the form object
    this.makeFormItem()

    // Load data needed in the form
    this.fetch()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  watch: {
    'form.Avdelingsid': function (newVal) {
      if (this.form.Avdelingsid === 3) {
        this.instillinger.kontrakttype = this.instillinger.kontrakttypeAll.filter(type => type.key === 'K')
      } else {
        this.instillinger.kontrakttype = this.instillinger.kontrakttypeAll
      }

      if (newVal === null) {
        console.log('No new val')
        if (this.kunde.Salar) {
          this.$set(this.form, 'Salar', this.kunde.Salar)
        } else {
          this.$set(this.form, 'Salar', 20)
        }
      } else {
        if (Number(this.form.Avdelingsid) === 2) {
          this.$set(this.form, 'Salar', 15)
        } else if (this.kunde.Salar) {
          this.$set(this.form, 'Salar', this.kunde.Salar)
        } else {
          this.$set(this.form, 'Salar', 20)
        }
      }
    }
  },
  methods: {
    makeFormItem: function () {
      let aid = localStorage.new_kontrakt_avdeling ? parseInt(localStorage.new_kontrakt_avdeling) : null

      let salar = this.kunde.Salar
      if (!salar) {
        salar = Number()
      }

      let defaults = {
        Avdelingsid: aid,
        Kontrakttype: localStorage.new_kontrakt_type ? localStorage.new_kontrakt_type : null,
        Mottaker: this.$store.getters.getUser.Brukernavn, // Me
        // Copy from kunde
        Salar: this.kunde.Salar || (aid === 2 ? 15 : 20), /// Vin 15
        Betalings_info: this.kunde.Betalings_info || '',
        Kontonummer: this.kunde.Kontonr || '',
        Legtype: this.kunde.Legtype || 0,
        Legitimert: false,
        Reise: false
      }

      this.form = Object.assign({}, this.form, defaults)
    },
    fetch: function () {
      this.loading = true

      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.mottaker.unshift({key: this.form.Mottaker, val: 'Laster...'})
      this.instillinger.avdeling.unshift({key: this.form.Avdelingsid, val: 'Laster...'})
      this.instillinger.kontrakttype.unshift({key: this.form.Kontrakttype, val: 'Laster...'})
      this.instillinger.legitimasjon.unshift({key: this.form.Legtype, val: 'Laster...'})

      KontraktService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.mottaker = data.bruker
          this.instillinger.mottaker.unshift({key: null, val: 'Velg kontraktansvarlig', disabled: true})

          this.instillinger.avdeling = data.avdeling
          this.instillinger.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})

          this.instillinger.kontrakttypeAll = data.kontrakttype
          if (this.form.Avdelingsid === 3) {
            this.instillinger.kontrakttype = this.instillinger.kontrakttypeAll.filter(type => type.key === 'K')
          } else {
            this.instillinger.kontrakttype = this.instillinger.kontrakttypeAll
          }
          this.instillinger.kontrakttype.unshift({key: null, val: 'Velg kontraksttype', disabled: true})

          this.instillinger.legitimasjon = data.legitimasjon
          this.instillinger.legitimasjon.unshift({key: 0, val: 'Velg legitimasjonstype'})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.loading = false
          this.setFormLoading(false)
        })
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // No errors, so try to save
            KundeService.saveKundeKontrakt(this.kunde.Kundenr, null, this.form)
              .then((response) => {
                // Take care of the response
                let newKontrakt = response.data

                localStorage.new_kontrakt_avdeling = newKontrakt.Avdelingsid
                localStorage.new_kontrakt_type = newKontrakt.Kontrakttype

                // Show success alert
                this.$helpers.showSuccessAlert('Kontrakt er lagret')

                // Emit event so we can update list
                bus.$emit('kunde-kontrakt-created', newKontrakt)

                this.closeModal()
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktCreateModal.vue